import { yup } from 'straightline-utils/validation';

export default (app) => {
  return yup.object({
    stripe_id: yup.string().trim().label('Stripe ID').required()
  });
};
